import styled from '../../../theme/styled-with-theme';
import { pxToRem } from '../../../styles/utils';
import { mediaQueries } from '../../../styles/media-queries';
import { Container, Input, Button as StyledButton } from '../styles';

export const PhoneNumberWrapper = styled(Container)`
  max-height: ${pxToRem(64)};
  width: fit-content;
`;

export const MobilePhoneNumberInput = styled(Input)`
  height: ${pxToRem(64)};
  width: ${pxToRem(312)};
  opacity: 1;
  flex: 1 1 auto;

  ${({ theme }) => `
    border: ${pxToRem(1)} solid ${theme.cfColor.green};
    border-radius: ${theme.borderRadius.input_desktop};
    padding: ${theme.spacing.ml};
    padding-right: ${pxToRem(130)};
    font-size: ${theme.fontSize.s};
    
    ::placeholder {
      font-size: ${theme.fontSize.s};
    }
  `}

  ${mediaQueries[0]} {
    height: ${pxToRem(48)};
    width: ${pxToRem(250)};
    padding: ${({ theme }) => theme.spacing.sm};
    padding-right: ${pxToRem(100)};
    font-size: ${({ theme }) => theme.fontSize['2xs']};

    border-radius: ${({ theme }) => theme.borderRadius.input};

    ::placeholder {
      font-size: ${({ theme }) => theme.fontSize['2xs']};
    }
  }

  @media (min-width: 321px) and (max-width: 350px) {
    width: 100%;
    padding-left: ${({ theme }) => theme.spacing.m};
    font-size: ${({ theme }) => theme.fontSize['2xs']};
    ::placeholder {
      font-size: ${({ theme }) => theme.fontSize['2xs']};
    }
  }

  ${mediaQueries.tablet} {
    width: ${pxToRem(280)};
    font-size: ${({ theme }) => theme.fontSize['2xs']};
    ::placeholder {
      font-size: ${({ theme }) => theme.fontSize['2xs']};
    }
  }

  ${mediaQueries.desktop} {
    border-radius: ${({ theme }) => theme.borderRadius.input_desktop};
    width: ${pxToRem(312)};
    font-size: ${({ theme }) => theme.fontSize.s};
    ::placeholder {
      font-size: ${({ theme }) => theme.fontSize.s};
    }
  }
`;

export const MobilePhoneNumberButton = styled(StyledButton)`
  position: absolute;
  right: ${({ theme }) => theme.spacing.s};

  ${mediaQueries[0]} {
    height: ${pxToRem(36)};
    width: fit-content;
    font-size: ${({ theme }) => theme.fontSize['2xs']};
    right: ${pxToRem(6)};
  }

  ${mediaQueries.min} {
    height: ${pxToRem(48)};
    width: ${pxToRem(112)};
    min-width: fit-content;
    font-size: ${({ theme }) => theme.fontSize.s};
    border-radius: ${({ theme }) => theme.borderRadius.cta_button_inside};
  }
`;
